import MatterTagsCard from "@/components/features/settings/defaults/matter-tags/MatterTagsCard";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/intake/tags")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.intakeSettingsTags)) {
    return <GlobalNotAuthorized />;
  }

  return <MatterTagsCard />;
}
